<div class="card flex justify-content-center">
    <p-accordion class="w-full background-249" [activeIndex]="0">
        <p-accordionTab iconPos="end">
            <ng-template pTemplate="header">
                    <div class="col-1" >
                        <img style="padding: unset; margin-left: -1em" src="assets/icons/table/ic64-docs.png" width="64" height="64">
                    </div>
                    <div class="col-11" style="margin-left: -2em">
                        <span class="white-space-nowrap postavka">
                            Поставка № {{supply['supplyNum']}}
                        </span>
                        <br>
                        <span class="h10-text">Статус: <img [src]="getPathtpStatusImg(supply.status ??'')" width="4" height="16" style="vertical-align: middle;"/> {{supply.status}}</span>
                    </div>
            </ng-template>

                    <div class="grid">
                        <div class="col-4" >
                           <div class="container"> 
                                <div class="col-12 column-placement">
                                    <span class="mobile-h10-text">МНН</span>
                                    <ul class="list">
                                        <li *ngFor="let mnn of supply.mnnNames" class="small-text"><span class="small-text overflow">{{ mnn }}</span></li>
                                    </ul>
                                </div>
                                <div class="grid">
                                    <div class="col-6 column-placement">
                                        <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Очікувана дата поставки</span>
                                        <span class="small-text" style="margin-left: .8em">{{supply.deliveryDate | date: 'dd.MM.yyyy'}}</span>
                                    </div>
                                    <div class="col-6 column-placement">
                                        <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Бюджетний рік</span>
                                        <span class="small-text" style="margin-left: .8em">{{supply.budgetYear}}</span>
                                    </div>
                                    <div class="col-6 column-placement">
                                        <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Фактична дата поставки</span>
                                        <span class="small-text" style="margin-left: .8em">{{supply.actualDeliveryDate | date: 'dd.MM.yyyy'}}</span>
                                    </div>
                                    <div class="col-6 column-placement">
                                        <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Склад партнера</span>
                                        <span class="small-text" style="margin-left: .8em">{{supply.warehouseName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="container">
                                <div class="col-12 column-placement">
                                    <span class="mobile-h10-text">Напрям</span>
                                    <ul class="list">
                                        <li *ngFor="let direction of supply.directions" class="small-text" >{{ direction.shortName }}</li>
                                    </ul>
                                </div>
                                <div class="col-12 column-placement">
                                    <span class="mobile-h10-text">Піднапрям</span>
                                    <ul class="list">
                                        <li *ngFor="let subDirection of supply.subDirections" class="small-text">{{ subDirection }}</li>
                                    </ul>
                                </div>
                                <div class="grid">
                                    <div class="col-4 column-placement">
                                        <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Тип товару</span>
                                        <span class="small-text" style="margin-left: .8em">{{supply.type}}</span>
                                    </div>
                                    <div class="col-4 column-placement">
                                        <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Номер договору</span>
                                        <span class="small-text" style="margin-left: .8em">{{supply.agreementNum}}</span>
                                    </div>
                                    <div class="col-4 column-placement">
                                        <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Бюджетна програма</span>
                                        <span class="small-text" style="margin-left: .8em">{{supply.budgetName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <div style="border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 100%">
                                <div class="column-placement col-12">
                                    <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Постачальник</span>
                                    <span class="small-text" style="margin-left: .8em">{{supply.supplierName}}</span>
                                </div>
                                <div class="column-placement col-12">
                                    <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Резидентність</span>
                                    <span class="small-text" style="margin-left: .8em">{{supply.residency}}</span>
                                </div>
                                <div class="column-placement col-12">
                                    <span class="mobile-h10-text" style="margin-left: 1em; margin-bottom: 1em">Відповідальний логіст</span>
                                    <span class="small-text" style="margin-left: .8em">{{supply.logisticManager}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
        </p-accordionTab>

    </p-accordion>
</div>

<div class="h7-heading mt-4">Товари</div>
<div class="h9-text color-666666">Оберіть товари за допомогою чекбоксів для подальшого розподілу</div>
<div class="table-wrapper">
    <p-table
            styleClass="p-datatable-sm"
            [scrollable]="true"
            scrollHeight="flex"
            selectionMode="single"
            [customSort]="true"
            [value]="goodsList"
            [lazy]="true"
            [resizableColumns]="true"
            columnResizeMode="expand"
            [columns]="tabHeader"
            [reorderableColumns]="true"
            (onLazyLoad)="loadData($event, true)"
            (onColReorder)="saveColumnOrder()"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>
                </th>
                <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeader" style="min-width: 10em" pReorderableColumn pResizableColumn>
                    <div style="display: inline-block" class="flex align-items-center h9-text" [ngStyle]="{'max-width': ['9', '10', '12', '14', '15', '16', '17'].includes(column.key) ? '13em': 'initial'}" [ngClass]="{'no-wrap': ['9', '10', '12', '14', '15', '16', '17'].includes(column.key)}">
                        {{ column.label }}&nbsp;
                        <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-good let-columns="columns">
            <tr class="table-content-text" (dblclick)="goToDetails(good.goodId)">
              <td>
                <med-checkbox size="small" *ngIf="'MZU' === dataService.userRoleValue.getValue() && good.specificationIds && good.specificationIds.length > 0"
                            (change)="onChangeHandlerGood(good)"
                            [value]="basketService.containsAnySpecificationId(good.specificationIds)"
                            [disabled]="basketService.hasTheDifferentDirection(good.directionId) || basketService.hasTheDifferentWarehouse(good.warehouseName)"></med-checkbox>
              </td>
              <ng-container *ngFor="let col of columns">
                <td style="word-break: keep-all; white-space: nowrap; min-width: 5rem" *ngIf="col.key === '1'">{{ good.mnnId }}</td>
                <td *ngIf="col.key === '2'">
                    <div style="word-break: keep-all; white-space: nowrap; min-width: 5rem">
                        {{ good.lovId }}
                    </div>
                </td>
                <td style="color: #666666"  *ngIf="col.key === '3'">
                    <ul style="margin: 0; padding: 0;">
                        <span style="word-break: keep-all; white-space: nowrap;">{{ good.direction.shortName }}</span>
                    </ul>
                </td>
                <td style="color: #666666" *ngIf="col.key === '4'">
                    <ul style="margin: 0; padding: 0;">
                        <span style="word-break: keep-all; white-space: nowrap;">{{ good.subDirection }}</span>
                    </ul>
                </td>
                <td style="color: #666666" *ngIf="col.key === '5'">
                    <ul style="margin: 0; padding: 0;">
                        <span style="word-break: keep-all; white-space: nowrap;">{{ good.mnnName }}</span>
                    </ul>
                </td>
                <td *ngIf="col.key === '6'">{{ good.dosage }}</td>
                <td *ngIf="col.key === '7'">{{ good.tradeName }}</td>
                <td *ngIf="col.key === '8'"><!--Виробник--></td>
                <td *ngIf="col.key === '9'"><!--Країна виробника--></td>
                <td *ngIf="col.key === '10'"><!--Країна походження--></td>
                <td *ngIf="col.key === '11'"><!--Кратність--></td>
                <td style="min-width: 15rem" *ngIf="col.key === '12'"><!--Серія/каталожний номер--></td>
                <td *ngIf="col.key === '13'">{{ good.quantity }}</td>
                <td style="min-width: 10rem" *ngIf="col.key === '14'">{{ good.unitPrice }}</td>
                <td style="min-width: 10rem" *ngIf="col.key === '15'">{{ good.totalPrice }}</td>
                <td *ngIf="col.key === '16'"><!--Дата виробництва--></td>
                <td *ngIf="col.key === '17'"><!--Термін придатності--></td>
            </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex flex-center flex-between">
                <med-pagination
                        [total]="totalRows"
                        [page]="selectedPageNumber"
                        [perPage]="pageSize"
                        (pageChange)="pageChange($event)"
                ></med-pagination>

                <div class="small-text">
                    Показано &nbsp;<span style="color: #000000" class="h10-text">{{ getFirstShowedRowIndex() }}-{{ getFirstShowedRowIndex() + pageSize }}</span> &nbsp;з {{ totalRows }}
                </div>

                <div>
                    <span class="small-text">Кількість на сторінку</span>
                    <med-radio-group
                            mode="buttons"
                            [value]="showedOnPage"
                            [options]="paginationOptions"
                            (onInput)="pageSizeChanged($event)"
                    ></med-radio-group>
                </div>
            </div>

        </ng-template>
    </p-table>
</div>
